import { render, staticRenderFns } from "./rmKlpt.vue?vue&type=template&id=5ee846eb"
import script from "./rmKlpt.vue?vue&type=script&lang=js"
export * from "./rmKlpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports